import React, { FC } from 'react';
import './EUFundingCard.css';

const EUFundingCard: FC = () => {
    return (
        <div className="eu-funding-card">
            <div className="eu-funding-logo">
                <img src="/funded.png" alt="Funded by the European Union" />
            </div>
            <div className="eu-funding-text">
                <p>
                    <strong>2024-2-PT01-KA210-VET-000277041</strong>
                    <br />
                    TransparencyChain - Tech and digital skills to foster competitive and sustainable value-chains in the crafts sector.
                    <br /><br />
                    Funded by the European Union. Views and opinions expressed are however those of the author(s) only and do not necessarily reflect those of the European Union or Agência Nacional Erasmus+ Educação e Formação. Neither the European Union nor the granting authority can be held responsible for them.
                </p>
            </div>
        </div>
    );
};

export default EUFundingCard;
